// styles and images
import "./RateSheets.css";
// components
import RateSheetTabs from "./RateSheetTabs";

export default function RateSheets() {
  return (
    <div className="container-fluid">
      <h2>Freight Rate Sheets</h2>
      <RateSheetTabs />
    </div>
  );
}
